import styled from 'styled-components'
import { theme } from '../../styles'

export const Sec = styled.section`
  margin-top: 38px;

  ${theme.mobile} {
    margin-top: 26px;
  }
`

export const SecHead = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
`

export const SecTitle = styled.h2`
  margin: 0;
  flex: none;
  white-space: nowrap;
  font-family: ${theme.fontes.serif};
  font-size: 23px;
  color: ${theme.cores.navy};
  font-weight: 700;

  ${theme.mobile} {
    font-size: 20px;
  }
`

export const SecRule = styled.span`
  flex: 1;
  height: 1px;
  background: ${theme.cores.line};
`

export const Telegram = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 18px;
  padding: 26px 30px;
  border-radius: ${theme.raio.lg};
  color: ${theme.cores.white};
  background: linear-gradient(120deg, ${theme.cores.navy} 0%, ${theme.cores.navy700} 60%, #34408A 100%);
  box-shadow: ${theme.sombras.md};

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.04) 0 2px, transparent 2px 22px);
    pointer-events: none;
  }

  ${theme.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 22px 20px;
    flex-wrap: wrap;
  }
`

export const TelegramIcon = styled.span`
  flex: none;
  display: grid;
  place-items: center;
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.13);

  svg {
    width: 32px;
    height: 32px;
  }
`

export const TelegramBody = styled.div`
  flex: 1;
  position: relative;
  z-index: 2;
  min-width: 220px;
`

export const TelegramTitle = styled.h3`
  margin: 0;
  font-family: ${theme.fontes.serif};
  font-size: 21px;
  font-weight: 700;
  color: ${theme.cores.white};
`

export const TelegramText = styled.p`
  margin: 4px 0 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13.5px;
  line-height: 1.4;
`

export const TelegramBtn = styled.a`
  position: relative;
  z-index: 2;
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 13px 22px;
  border-radius: 10px;
  background: ${theme.cores.accent};
  color: ${theme.cores.white};
  text-decoration: none;
  font-size: 14.5px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 6px 16px rgba(213, 112, 27, 0.4);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(213, 112, 27, 0.5);
  }

  ${theme.mobile} {
    width: 100%;
    justify-content: center;
  }
`
